export default __webpack_public_path__ + "static/media/2 BHK.c1e827b4.png";